export class SimulationKPI {
	co2ReductionTotal: number;
	savingTotal: number;
	investment: number;
	returnOnInvestment: number;
	treesSaved: number;
	breakEvenDurationInYears: number;
	chargingPointsToInstall: number;
}
